import RestClient from 'Services/RestClientService';
import { normalizeApiResponse } from 'Utils/ApiResponseHelper';
import {
  GET_SOURCEMARKETS_SUCCESS,
  GET_JOBFAMILIES_SUCCESS,
  GET_POSITION_TYPES_SUCCESS,
  GET_SEASONS_SUCCESS,
  GET_DESTINATIONS_SUCCESS,
  GET_JOBTITLES_SUCCESS,
  GET_COUNTRIES_SUCCESS,
  GET_REGIONS_SUCCESS,
  GET_KEYWORDS_SUCCESS,
  GET_MPLIDS_SUCCESS,
  GET_STAFF_STATUS_SUCCESS,
  GET_STAFF_NATIONALITIES_SUCCESS,
  GET_LANGUAGES_SUCCESS,
} from 'Constants/masterDataConstants';

export function getSourceMarkets() {
  const getSourceMarketSuccess = (sourceMarkets) => {
    return {
      type: GET_SOURCEMARKETS_SUCCESS,
      data: { sourceMarkets },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.sourceMarkets || masterData.sourceMarkets.length === 0) {
      const sourceMarkets = await RestClient.Get('masterdata/source-market');
      const normalizedData = normalizeApiResponse(sourceMarkets);
      const sourceMarketData = normalizedData.masterDataList;
      dispatch(getSourceMarketSuccess(sourceMarketData));
    }
  };
}

export function getJobFamilies() {
  const getJobFamiliesSuccess = (jobFamilies) => {
    return {
      type: GET_JOBFAMILIES_SUCCESS,
      data: { jobFamilies },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.jobFamilies || masterData.jobFamilies.length === 0) {
      const jobFamilies = await RestClient.Get('masterdata/job-family');
      const normalizedData = normalizeApiResponse(jobFamilies);
      const jobFamiliesData = normalizedData.masterDataList;
      dispatch(getJobFamiliesSuccess(jobFamiliesData));
    }
  };
}

export function getJobTitles() {
  const getJobTitlesSuccess = (jobTitles) => {
    return {
      type: GET_JOBTITLES_SUCCESS,
      data: { jobTitles },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.jobTitles || masterData.jobTitles.length === 0) {
      const jobTitles = await RestClient.Get('masterdata/job-title');
      const normalizedData = normalizeApiResponse(jobTitles);
      const jobTitlesData = normalizedData.masterDataList;
      dispatch(getJobTitlesSuccess(jobTitlesData));
    }
  };
}

export function getPositionTypes() {
  const getPositionTypesSuccess = (positionTypes) => {
    return {
      type: GET_POSITION_TYPES_SUCCESS,
      data: { positionTypes },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.positionTypes || masterData.positionTypes.length === 0) {
      const positionTypes = await RestClient.Get('masterdata/mpl-position-type');
      const normalizedData = normalizeApiResponse(positionTypes);
      const positionTypesData = normalizedData.masterDataList;
      dispatch(getPositionTypesSuccess(positionTypesData));
    }
  };
}

export function getSeasons() {
  const getSeasonsSuccess = (seasons) => {
    return {
      type: GET_SEASONS_SUCCESS,
      data: { seasons },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.seasons || masterData.seasons.length === 0) {
      const seasons = await RestClient.Get('masterdata/season');
      const normalizedData = normalizeApiResponse(seasons);
      const seasonsData = normalizedData.masterDataList;
      dispatch(getSeasonsSuccess(seasonsData));
    }
  };
}

export function getCountries() {
  const getCountriesSuccess = (countries) => {
    return {
      type: GET_COUNTRIES_SUCCESS,
      data: { countries },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.countries || masterData.countries.length === 0) {
      const countries = await RestClient.Get('masterdata/country');
      const normalizedData = normalizeApiResponse(countries);
      const countriesData = normalizedData.masterDataList;
      dispatch(getCountriesSuccess(countriesData));
    }
  };
}

export function getRegions() {
  const getRegionsSuccess = (regions) => {
    return {
      type: GET_REGIONS_SUCCESS,
      data: { regions },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.regions || masterData.regions.length === 0) {
      const regions = await RestClient.Get('masterdata/region');
      const normalizedData = normalizeApiResponse(regions);
      const regionsData = normalizedData.masterDataList;
      dispatch(getRegionsSuccess(regionsData));
    }
  };
}

export function getDestinations() {
  const getDestinationsSuccess = (destinations) => {
    return {
      type: GET_DESTINATIONS_SUCCESS,
      data: { destinations },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.destinations || masterData.destinations.length === 0) {
      const destinations = await RestClient.Get('masterdata/destination');
      const normalizedData = normalizeApiResponse(destinations);
      const destinationsData = normalizedData.masterDataList;
      dispatch(getDestinationsSuccess(destinationsData));
    }
  };
}

export function getKeyWords() {
  const getKeyWordsSuccess = (keywords) => {
    return {
      type: GET_KEYWORDS_SUCCESS,
      data: { keywords },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.keywords || masterData.keywords.length === 0) {
      const keywords = await RestClient.Get('setting/keywords');
      const normalizedData = normalizeApiResponse(keywords);
      dispatch(getKeyWordsSuccess(normalizedData));
    }
  };
}

export function getMplids() {
  const getMplidsSuccess = (mplids) => {
    return {
      type: GET_MPLIDS_SUCCESS,
      data: { mplids },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.mplids || masterData.mplids.length === 0) {
      const mplids = await RestClient.Get('masterdata/mplid');
      const normalizedData = normalizeApiResponse(mplids);
      const mplidsData = normalizedData.masterDataList;
      dispatch(getMplidsSuccess(mplidsData));
    }
  };
}

export function getStaffStatus() {
  const getStaffStatusSuccess = (staffStatus) => {
    return {
      type: GET_STAFF_STATUS_SUCCESS,
      data: { staffStatus },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.staffStatus || masterData.staffStatus.length === 0) {
      const staffStatus = await RestClient.Get('masterdata/staff-status');
      const normalizedData = normalizeApiResponse(staffStatus);
      const staffStatusData = normalizedData.masterDataList;
      dispatch(getStaffStatusSuccess(staffStatusData));
    }
  };
}

export function getStaffNationalities() {
  const getStaffNationalitiesSuccess = (staffNationalities) => {
    return {
      type: GET_STAFF_NATIONALITIES_SUCCESS,
      data: { staffNationalities },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.staffNationalities || masterData.staffNationalities.length === 0) {
      const staffNationalities = await RestClient.Get('masterdata/staff-nationalies');
      const normalizedData = normalizeApiResponse(staffNationalities);
      const staffNationalitiesData = normalizedData.masterDataList;
      dispatch(getStaffNationalitiesSuccess(staffNationalitiesData));
    }
  };
}

export function getLanguages() {
  const getLanguagesSuccess = (languages) => {
    return {
      type: GET_LANGUAGES_SUCCESS,
      data: { languages },
    };
  };

  return async function (dispatch, getState) {
    const { masterData } = getState();
    if (!masterData.languages || masterData.languages.length === 0) {
      const languages = await RestClient.Get('masterdata/language');
      const normalizedData = normalizeApiResponse(languages);
      const languagesData = normalizedData.masterDataList;
      dispatch(getLanguagesSuccess(languagesData));
    }
  };
}
